
export const REQUEST_SEND_REJECT = 'REQUEST_SEND_REJECT';
export const REJECTION_RESPONSE_RECEIVED = 'REJECTION_RESPONSE_RECEIVED';